// extracted by mini-css-extract-plugin
export var searchHeader = "_5t-0";
export var searchHeaderDark = "_5t-1";